import * as React from "react";
import { useSelector } from "react-redux";
import { BreadcrumbItems } from "@emisgroup/cohort-builder-kit";
import { Tabs } from "../../../Common/UI/Index";
import { TabListProps } from "../../../Common/UI/Tabs/Tabs";
import { IRootState } from "../../../../reducer/CombineReducer";
import { TabListProvider } from "../../../AppConfig/TabListProvider/TabListProvider";
import { BreadcrumbsContainer } from "../../BreadcrumbsContainer/BreadcrumbsContainer";
import { Navigation } from "./Types";
import "./Style.scss";

export interface INavigation {
  menu: Navigation;
  menuSelectHandle: (currentMenu: Navigation) => void;
  tabsList?: TabListProps[];
}

/**
 * Responsible for rendering the right panel component
 */
const ExtractNavigation: React.FC<INavigation> = (props: INavigation) => {

  const extractState = useSelector((state: IRootState) => state.extractState);
  const selectedExtract = extractState?.selectedExtract;
  const initialItem: BreadcrumbItems[] = React.useMemo(() => {
    return [{
      name: selectedExtract?.extractName || ""
    }];
  }, [selectedExtract]);

  const [items, setItems] = React.useState<BreadcrumbItems[]>(initialItem);

  /**
   * Capitalizes the first letter
   * @param string String
   * @returns String with first letter capital
   */
  const capitalizeFirstLetter = (string: string): string => {
    return string?.charAt(0)?.toUpperCase() + string?.slice(1);
  };

  const menuSelectHandle = (selectedMenu: string): void => {
    const modifiedSelectedMenu = selectedMenu.replace(/-/g, " ");
    const customSelectedMenu = modifiedSelectedMenu.charAt(0).toUpperCase() + modifiedSelectedMenu.slice(1);
    switch (customSelectedMenu) {
      case Navigation.DETAILS:
        return props.menuSelectHandle(Navigation.DETAILS);
      case Navigation.SCHEDULING:
        return props.menuSelectHandle(Navigation.SCHEDULING);
      case Navigation.VERSIONING:
        return props.menuSelectHandle(Navigation.VERSIONING);
      case Navigation.QA:
        return props.menuSelectHandle(Navigation.QA);
      case Navigation.OPTOUT:
        return props.menuSelectHandle(Navigation.OPTOUT);
      case Navigation.OUTPUT:
        return props.menuSelectHandle(Navigation.OUTPUT);
      case Navigation.RESULTS:
        return props.menuSelectHandle(Navigation.RESULTS);
    }
  };

  const getSelectedMenu = (): string => {
    const menuPropToKey = props?.menu?.replace(/\s+/g, "-")?.toLowerCase();
    const activeMenuTab = props?.tabsList?.find((tabsMenu: TabListProps) => tabsMenu.value === menuPropToKey);

    if (activeMenuTab && activeMenuTab.value === menuPropToKey) {
      return activeMenuTab.value;
    }

    return "";
  };

  // Updates the store based on active tab. Can be also used for other tabs than execute
  React.useEffect(() => {
    if (getSelectedMenu()) {
      const newItems = [...initialItem];
      newItems.push({
        name: (capitalizeFirstLetter(getSelectedMenu())),
      });

      setItems(newItems);
    }
  }, [getSelectedMenu(), initialItem]);

  return (
    <div className="ebt-extract-navigation" data-testid="ebt-extract-navigation">
      <div className="eb-extract-navigation-breadcrumbs">
        <BreadcrumbsContainer
          reportName={items?.[0]?.name}
          activeTab={getSelectedMenu()}
        />
      </div>
      <Tabs
        activeTab={getSelectedMenu()}
        tabsList={props?.tabsList as TabListProps[]}
        onTabChange={(tab: string): void => menuSelectHandle(tab)}
      />
    </div>
  );
};

const ExtractNavigationWithTabsList = TabListProvider(ExtractNavigation);
export default ExtractNavigationWithTabsList;
